export default __webpack_public_path__ + "static/media/newLogo.c72c073a.png";